"use strict";
exports.__esModule = true;
exports.CREDIT_BUILDER_WAITING_OFFER = void 0;
exports.CREDIT_BUILDER_WAITING_OFFER = {
    HEADER: 'Your credit boost is almost here...',
    HIGHLIGHT: 'Raise your score 45 points in 1 month*',
    BODY: 'Please keep the app open\nwhile we process your application.\nThis may take a few minutes.',
    BODY_WEB: 'Please keep the app open while we process your application. \nThis may take a few minutes.',
    DISCLAIMER: '*Based on real customers data with a starting score below 560.'
};
